module.exports = __webpack_public_path__ + "static/media/create_article@2x.22efc936.png";